var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NowhowDropdown',{attrs:{"id":_vm.id + '-yes-no-null',"name":_vm.name ? _vm.name : _vm.id,"value":_vm.valueAsString(),"items":_vm.yesNoNullItems,"label":_vm.label,"validate":_vm.validate,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"change":_vm.onChange,"input":_vm.onInput,"focusout":_vm.onFocusout}})
}
var staticRenderFns = []

export { render, staticRenderFns }